The event that was attempted to be delivered.
